import { useMountEffect } from "@react-hookz/web";
import { useNavigate } from "react-router";

import type { FC } from "react";

const EventsPage: FC = () => {
  const navigate = useNavigate();

  useMountEffect(() => navigate("/manage/employee_data/events", { replace: true }));

  return <></>;
};

export default EventsPage;
